import { Injectable, Inject, PLATFORM_ID } from "@angular/core";
import { DatePipe, isPlatformBrowser, DOCUMENT } from "@angular/common";
import { AbstractControl, FormControl, FormGroupDirective, ValidationErrors } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from "./api.service";
import { Title, Meta } from "@angular/platform-browser";
import { map, filter, mergeMap } from "rxjs/operators";
import { NavigationEnd } from "@angular/router";
import { FileSaverService } from "ngx-filesaver";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { UserService } from "./user.service";
import * as moment from 'moment/moment.js';
import { DialogPosition, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ExitPopUpComponent } from "../components/exit-pop-up/exit-pop-up.component";
import { BehaviorSubject } from "rxjs";


@Injectable({
    providedIn: "root",
})
export class GlobalService {
    basePrefix = "https://songdew.com";
    adminId = 12924;
    adminSlug = "songdew-12924";
    isMultipleFollow = false;
    red = "#ef1d27";
    red2 = "#e9573f";
    skyblue = "#4dc5f9";
    lightgrey = "#a7a7a7";
    light = "#f2f4f8";
    blue = "#545ca6";
    blue2 = "#0037ff";
    pageType = '';

    profileUser = '';
    // distribution settings
    DmaxAudioSize = 200;
    DalbumArtWidth = 3000;
    DallowOnlyNumbers = /^[0-9]+$/;
    //DtrackTitleRegex = /^[a-zA-Z0-9!@#$&()\\-~_`*.+, |\s?'^\="]*$/;
    //DtrackTitleRegex = /^[a-zA-Z0-9!@#$%^&*()_+`~\-=\[\]{}':;"\\|,?.\/\s]+$/;
    DtrackTitleRegex = /^[a-zA-Z0-9\u00C0-\u024F!@#$%^&*()_+`~\-=\[\]{}':;"“”‘’\\|,?.\/\s]+$/;

    Dversion = /^[a-zA-Z0-9\u00C0-\u024F ]{0,120}$/;
    DartistsCountAllowed = 5;
    validAudioTypesDistribution = "audio/wav, audio/x-wav";
    DimageUploadDimensionsValidationError =
        "Artwork should be a square image with atleast " + this.DalbumArtWidth + "*" + this.DalbumArtWidth;
    distributionReleaseDate = moment().add(7, 'days').calendar();
    reReleaseDistributionDate = moment().add(15, 'days').calendar();
    maxReleaseDate = moment().add(60, 'days').calendar();
    maxRereleaseDate = moment().add(60, 'days').calendar();
    todayDate = moment().format('YYYY-MM-DD');
    //Dappleregex=/^(?:https:\/\/music\.apple\.com)([\/:])([a-z]\w)([\/:])artist\1([^\/]+)/;
    DvalidImageTypes = "image/jpg, image/jpeg";
    DvalidImageTypesError = 'Image must be in jpeg format.'
    validPdfTypes = 'application/pdf';
    // Distribution //


    public isVisitStart = new BehaviorSubject<boolean>(false);
    public isMobileVisitStar = new BehaviorSubject<boolean>(false);
    public widgetStart = new BehaviorSubject<boolean>(false);


    showPlayer: Boolean = false;

    shoskeleBanner: any;
    Is_set_shoskeleBanner = false;
    maxAudioSize = 100;
    maxAlbumArtSize = 2;
    albumArtWidth = 500;

    maxSongTitleLength = 120;

    oppDetailPrefix = "opportunities";
    songDetailPrefix = "songs";
    albumDetailPrefix = "albums";
    playlistDetailPrefix = "playlists";
    videoDetailPrefix = "video-songs";
    blogDetailPrefix = "blog";
    buyLinkURLRegex = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
    specialCharRegex = /^\`|\~|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\+|\=|\[|\{|\]|\}|\||\\|\'|\<|\,|\.|\>|\?|\/|\""|\;|\:+$/;
    emailRegex = /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    socialUsernameRegex = /^([a-zA-Z\d.\/_]){1,}$/;
    socialMedia = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';

    socialMediaFB = /^(?:(http|https):\/\/)?(?:www\.)?facebook\.com\/(?:(?:\w)*#!\/)?(?:pages\/)?(?:[\w\-]*\/)*([\w\-]*)/;
    socialMediaInsta = /^(?:(?:http|https):\/\/)?(?:www\.)?(?:instagram\.com|instagr\.am)\/([A-Za-z0-9-_\.]+)?/;
    socialMediaYtb = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)/;
    socailMediaTwitter = /^(http|https)(?:s)?:\/\/(?:www\.)?twitter\.com\/([a-zA-Z0-9_]+)/;
    spotifyLinkRegex = /^(?:https:\/\/open\.spotify\.com|spotify)([\/:])artist\1([^\/]+)/;
    Dappleregex = /^(?:https?:\/\/)?(?:music|itunes)\.apple\.com\/(?:[a-z]{2}\/)?artist\/(?:[^\/]+\/)?(?:id)?\d+|\d+$/i;







    titleCharRegex = /^[a-zA-Z0-9\u00C0-\u024F\s!@#$&()\\-`.+,/\"]*$/;
    //artistsNamesRegex = /^[a-zA-Z '-]{0,120}$/;
    artistsNamesRegex = /^[^<>?]{0,120}$/;
    trackTitleRegex = /^.*$/;
    version = /^\d+([,.]\d+)?$/;
    allowOnlyNumbers = /^[0-9]+$/;
    registerFirstNamesRegex = /^[a-zA-Z\u00C0-\u024F '-]{0,50}$/;
    registerSongdewUrl = /^[a-zA-Z0-9 '-]{0,50}$/;


    onlyAlpha = /^[a-zA-Z\u00C0-\u024F']{0,50}$/;

    validImageTypes = "image/png, image/jpg, image/jpeg";
    validAudioTypes = "audio/mp3, audio/mpeg, audio/wav, audio/flac, audio/x-wav";

    imageUploadValidationHint = "Supported Formats: .jpeg, .png";
    imageUploadSizeValidationHint =
        "Image Size should not exceed 2MB and must be atleast 500 px * 500 px";
    imageUploadValidationError =
        "The file format selected is not .jpeg or .png";
    imageUploadSizeValidationError =
        "The file selected exceeds " + this.maxAlbumArtSize + " MB";
    imageUploadDimensionsValidationError =
        "The image must be atleast " + this.albumArtWidth + "*" + this.albumArtWidth;

    audioUploadValidationHint = "Supported Formats: .mp3, .wav, .flac";
    audioUploadSizeValidationHint =
        "File Size should not exceed " + this.maxAudioSize + " MB";
    audioUploadValidationError =
        "The file format selected is not .mp3, .wav or .flac";
    audioUploadSizeValidationError =
        "The file selected exceeds " + this.maxAudioSize + " MB";

    windowWidth = 1000;

    defaultData: any;

    public text = `{ "text": "This is text file!中文" }`;

    guides = {
        dashboard: false,
        claps: false,
        schedule: false,
    };

    imageSub: any = [];
    imageVal: any = [];
    imageDefaultValue: any = [];

    globalSpinner: Boolean = false;
    globalProgressBar: Boolean = false;
    downloadInterrupt: Boolean = false;
    changeTab: Boolean = false;

    ua = navigator.userAgent || navigator.vendor;
    uaLower = this.ua.toLowerCase();

    isInstagram = this.ua.indexOf("Instagram") > -1 ? true : false;
    isFacebook =
        this.ua.indexOf("FBAN") > -1 || this.ua.indexOf("FBAV") > -1
            ? true
            : false;

    isBrowser: Boolean = false;

    activeNavTabs = "";

    embed = false;

    mainScrollablePos = 0;

    agreements = false;

    oppSelectedLang = "english";

    newUserFirstSession = false;
    sanitizer: any;
    cookie: any;
    showSubscription: Boolean = true;
    isSongDistribute: Boolean = false;
    iscardDownloadError: Boolean = false;

    constructor(
        @Inject(PLATFORM_ID) private platform: Object,
        private _httpClient: HttpClient,
        private _FileSaverService: FileSaverService,
        private datepipe: DatePipe,
        private titleService: Title,
        private metaService: Meta,
        private router: Router,
        public route: ActivatedRoute,
        private api: ApiService,
        private user: UserService,
        @Inject(DOCUMENT) private doc,
        private dialog: MatDialog,

    ) {
        if (isPlatformBrowser(this.platform)) {
            this.isBrowser = true;
        }



        // console.log('this.isBrowser');
        // console.log(this.isBrowser);

        this.router.events
            .pipe(
                filter((e) => e instanceof NavigationEnd),
                map(() => this.route),
                map((route) => {
                    if (route.firstChild) {
                        route = route.firstChild;
                    }

                    return route;
                }),
                filter((route) => route.outlet === "primary"),
                mergeMap((route) => route.data)
            )
            .subscribe((e) => {
                this.defaultData = {
                    title: e.metaTitle,
                    description: e.metaDescription,
                    keywords: e.metaKeywords,
                    url: this.router.url,
                    img: e.metaImg,
                };
            });

        this.windowWidth = window.innerWidth;
        window.onresize = (e) => {
            this.windowWidth = window.innerWidth;

            this.isSmallMobile();
            this.isMobile();
            this.isTablet();
            this.isSdTablet();
            this.isExceptMobile();
            this.isDesktop();

            if (this.isBrowser) {
                $(".owl-carousel").trigger("refresh.owl.carousel");
                $("owl-carousel").trigger("refresh.owl.carousel");
            }
        };
    }

    popupDialogRef: MatDialogRef<ExitPopUpComponent>;



    openHelpdesk() {
        if (this.isBrowser) {
            window.open(
                this.api.helpdeskUrl(this.user.token),
                '_blank',
                'noopener,noreferrer'
            );
        }
    }



    public async CheckUserProStatus() {
        return new Promise<boolean>((resolve, reject) => {
            this.api.subCheck().subscribe(res => {
                if (res.success && res.pro == 1) {
                    this.user.isProMember = res.pro;
                    resolve(true);
                } else if (res.success && res.pro == 2) {
                    this.user.isProMember = res.pro;
                    resolve(false);
                } else {
                    this.user.isProMember = 0;
                    resolve(false);
                }
            });
        });
    }


    public userProType() {
        return this.user.isProMember;
    }

    public getDefaultImage(image: string, defaultImg: string) {
        return image ? image : defaultImg;
    }

    public cropImage(image, w, h = w) {
        /*
        let croppedImage = '';
        let croppedImageArray = [''];
        if ( image != null && image != undefined ) {
            croppedImageArray = image.split('sgmedia/');
        }

        if ( croppedImageArray.length > 1 ) {
            croppedImage = croppedImageArray[0] + 'sgmedia/' + w+'x'+h + '/' + croppedImageArray[1];
        } else {
            croppedImage = croppedImageArray[0];
        }

        return croppedImage;*/

        if (image != null && image != undefined) {
            // image = image.split("?w=")[0];
            return image;
        } else {
            return image;
        }

        if (
            image == null ||
            image == undefined ||
            image == "" ||
            image.split("?w=").length > 1
        ) {
            return image;
        } else {
            if (image.indexOf("?w=") > -1) {
                return image.split("?w=")[0] + "?w=" + w;
            }

            const croppedImage = image + "?w=" + w;
            return croppedImage;
        }
    }

    public saveFile(filePath, name, fromRemote: boolean = true) {
        if (this.isBrowser) {
            this.globalSpinner = true;
            this.api.freeDownload(filePath);
            this.iscardDownloadError = false;

            const fileName =
                name +
                "." +
                filePath.split(".")[filePath.split(".").length - 1];
            if (fromRemote) {
                this._httpClient
                    .get(filePath, {
                        observe: "response",
                        responseType: "blob",
                    })
                    .subscribe(
                        (res) => {
                            this._FileSaverService.save(res.body, fileName);
                            this.globalSpinner = false;
                        },
                        (err: HttpErrorResponse) => {
                            this.globalSpinner = false;
                            this.iscardDownloadError = true;
                        }
                    );
                return;
            }
            const fileType = this._FileSaverService.genType(fileName);
            const txtBlob = new Blob([this.text], { type: fileType });
            this._FileSaverService.save(txtBlob, fileName);
        }
    }

    public toCapitalize(string) {
        return string
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
    }

    public getYoutubeUrl(url) {
        if (!url || url == "") {
            return "";
        }
        const youTubeURL = url.replace(/(>|<)/gi, '')
        return youTubeURL;

    }

    public getYoutubeImage(url) {
        if (!url || url == "") {
            return "";
        }

        var ytId = this.getYoutubeIdByUrl(url);
        const youtubeID = `https://img.youtube.com/vi/${ytId}/hqdefault.jpg`;
        return youtubeID;
    }


    public setMeta(apiData, ampLink = "") {
        let data = apiData;
        // console.log('setMeta');
        // console.log('API Meta: ', data);

        if (
            (data.title == undefined || data.title == null) &&
            this.route.snapshot.firstChild != undefined &&
            this.route.snapshot.firstChild != null &&
            this.route.snapshot.firstChild.data.metaTitle != undefined &&
            this.route.snapshot.firstChild.data.metaTitle != null
        ) {
            data.title = this.route.snapshot.firstChild.data.metaTitle;
        } else if (
            (data.title == undefined || data.title == null) &&
            this.route.snapshot.firstChild != undefined &&
            this.route.snapshot.firstChild != null &&
            this.route.snapshot.firstChild.firstChild != undefined &&
            this.route.snapshot.firstChild.firstChild != null &&
            this.route.snapshot.firstChild.firstChild.data.metaTitle !=
            undefined &&
            this.route.snapshot.firstChild.firstChild.data.metaTitle != null
        ) {
            data.title =
                this.route.snapshot.firstChild.firstChild.data.metaTitle;
        } else if (
            (data.title == undefined || data.title == null) &&
            this.route.snapshot.firstChild != undefined &&
            this.route.snapshot.firstChild != null &&
            this.route.snapshot.firstChild.firstChild != undefined &&
            this.route.snapshot.firstChild.firstChild != null &&
            this.route.snapshot.firstChild.firstChild.firstChild != undefined &&
            this.route.snapshot.firstChild.firstChild.firstChild != null &&
            this.route.snapshot.firstChild.firstChild.firstChild.data
                .metaTitle != undefined &&
            this.route.snapshot.firstChild.firstChild.firstChild.data
                .metaTitle != null
        ) {
            data.title =
                this.route.snapshot.firstChild.firstChild.firstChild.data.metaTitle;
        }

        if (
            (data.description == undefined || data.description == null) &&
            this.route.snapshot.firstChild != undefined &&
            this.route.snapshot.firstChild != null &&
            this.route.snapshot.firstChild.data.metaDescription != undefined &&
            this.route.snapshot.firstChild.data.metaDescription != null
        ) {
            data.description =
                this.route.snapshot.firstChild.data.metaDescription;
        } else if (
            (data.description == undefined || data.description == null) &&
            this.route.snapshot.firstChild != undefined &&
            this.route.snapshot.firstChild != null &&
            this.route.snapshot.firstChild.firstChild != undefined &&
            this.route.snapshot.firstChild.firstChild != null &&
            this.route.snapshot.firstChild.firstChild.data.metaDescription !=
            undefined &&
            this.route.snapshot.firstChild.firstChild.data.metaDescription !=
            null
        ) {
            data.description =
                this.route.snapshot.firstChild.firstChild.data.metaDescription;
        } else if (
            (data.description == undefined || data.description == null) &&
            this.route.snapshot.firstChild != undefined &&
            this.route.snapshot.firstChild != null &&
            this.route.snapshot.firstChild.firstChild != undefined &&
            this.route.snapshot.firstChild.firstChild != null &&
            this.route.snapshot.firstChild.firstChild.firstChild != undefined &&
            this.route.snapshot.firstChild.firstChild.firstChild != null &&
            this.route.snapshot.firstChild.firstChild.firstChild.data
                .metaDescription != undefined &&
            this.route.snapshot.firstChild.firstChild.firstChild.data
                .metaDescription != null
        ) {
            data.description =
                this.route.snapshot.firstChild.firstChild.firstChild.data.metaDescription;
        }

        if (
            (data.keywords == undefined || data.keywords == null) &&
            this.route.snapshot.firstChild != undefined &&
            this.route.snapshot.firstChild != null &&
            this.route.snapshot.firstChild.data.keywords != undefined &&
            this.route.snapshot.firstChild.data.keywords != null
        ) {
            data.keywords = this.route.snapshot.firstChild.data.keywords;
        } else if (
            (data.keywords == undefined || data.keywords == null) &&
            this.route.snapshot.firstChild != undefined &&
            this.route.snapshot.firstChild != null &&
            this.route.snapshot.firstChild.firstChild != undefined &&
            this.route.snapshot.firstChild.firstChild != null &&
            this.route.snapshot.firstChild.firstChild.data.keywords !=
            undefined &&
            this.route.snapshot.firstChild.firstChild.data.keywords != null
        ) {
            data.keywords =
                this.route.snapshot.firstChild.firstChild.data.keywords;
        } else if (
            (data.keywords == undefined || data.keywords == null) &&
            this.route.snapshot.firstChild != undefined &&
            this.route.snapshot.firstChild != null &&
            this.route.snapshot.firstChild.firstChild != undefined &&
            this.route.snapshot.firstChild.firstChild != null &&
            this.route.snapshot.firstChild.firstChild.firstChild != undefined &&
            this.route.snapshot.firstChild.firstChild.firstChild != null &&
            this.route.snapshot.firstChild.firstChild.firstChild.data
                .keywords != undefined &&
            this.route.snapshot.firstChild.firstChild.firstChild.data
                .keywords != null
        ) {
            data.keywords =
                this.route.snapshot.firstChild.firstChild.firstChild.data.keywords;
        }

        if (data.url == undefined || data.url == null) {
            data.url = this.basePrefix + this.router.url;
        }
        data.url = data.url.split("?")[0];
        data.url = data.url.split("#")[0];

        if (data.img == undefined || data.img == null) {
            if (
                this.route.snapshot.firstChild != undefined &&
                this.route.snapshot.firstChild != null &&
                this.route.snapshot.firstChild.data.metaImg != undefined &&
                this.route.snapshot.firstChild.data.metaImg != null &&
                this.route.snapshot.firstChild.data.metaImg != ""
            ) {
                data.img = this.route.snapshot.firstChild.data.metaImg;
            } else if (
                this.route.snapshot.firstChild != undefined &&
                this.route.snapshot.firstChild != null &&
                this.route.snapshot.firstChild.firstChild != undefined &&
                this.route.snapshot.firstChild.firstChild != null &&
                this.route.snapshot.firstChild.firstChild.data.metaImg !=
                undefined &&
                this.route.snapshot.firstChild.firstChild.data.metaImg !=
                null &&
                this.route.snapshot.firstChild.firstChild.data.metaImg != ""
            ) {
                data.img =
                    this.route.snapshot.firstChild.firstChild.data.metaImg;
            } else if (
                this.route.snapshot.firstChild != undefined &&
                this.route.snapshot.firstChild != null &&
                this.route.snapshot.firstChild.firstChild != undefined &&
                this.route.snapshot.firstChild.firstChild != null &&
                this.route.snapshot.firstChild.firstChild.firstChild !=
                undefined &&
                this.route.snapshot.firstChild.firstChild.firstChild != null &&
                this.route.snapshot.firstChild.firstChild.firstChild.data
                    .metaImg != undefined &&
                this.route.snapshot.firstChild.firstChild.firstChild.data
                    .metaImg != null &&
                this.route.snapshot.firstChild.firstChild.firstChild.data
                    .metaImg != ""
            ) {
                data.img =
                    this.route.snapshot.firstChild.firstChild.data.metaImg;
            } else {
                data.img =
                    "https://songdewnetwork.com/sgmedia/assets/images/homeogimage.jpg";
            }
        }

        let width = this.getOgSize(data.size, 0);
        let height = this.getOgSize(data.size, 1);

        if (data.img == undefined || data.img == null || data.img == "") {
            data.img =
                "https://songdewnetwork.com/sgmedia/assets/images/homeogimage.jpg";
        }
        data.img = data.img.split("?w=")[0] + "?w=" + width;

        data.title =
            data.title == undefined || data.title == null ? "" : data.title;
        data.description =
            data.description == undefined || data.description == null
                ? ""
                : data.description;
        data.title = this.toCapitalize(data.title);

        const undefinedWord = /undefined/gi;
        const doubleSpace = /  /gi;
        data.title = data.title
            .replace(undefinedWord, "")
            .replace(doubleSpace, " ");
        data.description = data.description
            .replace(undefinedWord, "")
            .replace(doubleSpace, " ");

        // console.log('Final Meta: ', data);

        this.titleService.setTitle(data.title);

        this.metaService.updateTag({
            name: "description",
            content: data.description,
        });
        this.metaService.updateTag({
            name: "keywords",
            content:
                data.keywords == undefined || data.keywords == null
                    ? ""
                    : data.keywords,
        });

        this.metaService.updateTag({ property: "og:url", content: data.url });
        this.metaService.updateTag({
            property: "og:title",
            content: data.title,
        });
        this.metaService.updateTag({
            property: "og:description",
            content: data.description,
        });
        this.metaService.updateTag({ property: "og:image", content: data.img });
        this.metaService.updateTag({
            property: "og:image:width",
            content: width.toString(),
        });
        this.metaService.updateTag({
            property: "og:image:height",
            content: height.toString(),
        });

        this.metaService.updateTag({ name: "twitter:url", content: data.url });
        this.metaService.updateTag({
            name: "twitter:title",
            content: data.title,
        });
        this.metaService.updateTag({
            name: "twitter:description",
            content: data.description,
        });
        this.metaService.updateTag({
            name: "twitter:image",
            content: data.img,
        });

        let canonical = this.doc.querySelector("link[rel='canonical']");
        canonical.setAttribute("href", data.url);

        let ampOld = this.doc.querySelector("link[rel='amphtml']");
        if (ampOld != undefined && ampOld != null) {
            ampOld.parentNode.removeChild(ampOld);
        }

        if (ampLink != "") {
            let amp: HTMLLinkElement = this.doc.createElement("link");
            amp.setAttribute("rel", "amphtml");
            this.doc.head.appendChild(amp);
            amp.setAttribute("href", this.basePrefix + ampLink);
        }

        this.metaService.updateTag({
            name: "prerender-status-code",
            content: "200",
        });

        // window['prerenderReady'] = true;

        if (this.isBrowser) {
            let browser = "Other";

            if (this.isInstagram) {
                browser = "Instagram Web View";
            } else if (this.isFacebook) {
                browser = "Facebook Web View";
            } else if (this.uaLower.indexOf("edge") > -1) {
                browser = "Edge";
            } else if (
                this.uaLower.indexOf("opr") > -1 &&
                !!(<any>window).opr
            ) {
                browser = "Opera";
            } else if (
                this.uaLower.indexOf("chrome") > -1 &&
                !!(<any>window).chrome
            ) {
                browser = "Chrome";
            } else if (this.uaLower.indexOf("trident") > -1) {
                browser = "IE";
            } else if (this.uaLower.indexOf("firefox") > -1) {
                browser = "Firefox";
            } else if (this.uaLower.indexOf("safari") > -1) {
                browser = "Safari";
            } else {
                browser = "Other";
            }

            // console.log('GA Page View: ' + data.url);
            // console.log('dimension1: ' + this.user.slug);
            // console.log('dimension2: ' + this.user.type);
            // console.log('dimension3: ' + browser);

            /* (<any>window).ga("set", "dimension1", this.user.slug);
             (<any>window).ga("set", "dimension2", this.user.type);
             (<any>window).ga("set", "dimension3", browser);
             (<any>window).ga("set", "page", this.router.url);
             (<any>window).ga("send", "pageview");*/
        }
    }

    getOgSize(type = "", dimension = 0) {
        let width = 600;
        let height = 450;
        if (type == "song" || type == "album" || type == "playlist") {
            width = 200;
            height = 200;
        } else if (type == "video") {
            width = 640;
            height = 480;
        } else if (type == "blog") {
            width = 900;
            height = 450;
        }

        if (dimension != 1) {
            return width;
        } else {
            return height;
        }
    }

    isSmallMobile() {
        return this.windowWidth <= 370 ? true : false;
    }

    isMobile() {
        return this.windowWidth <= 767 ? true : false;
    }

    isTablet() {
        return this.windowWidth <= 991 ? true : false;
    }

    isSdTablet() {
        return this.windowWidth <= 1024 ? true : false;
    }

    isExceptMobile() {
        return this.windowWidth > 767 ? true : false;
    }

    isDesktop() {
        return this.windowWidth > 1024 ? true : false;
    }

    getYoutubeIdByUrl(url) {
        if (url != null) {
            const YTUrl = url.toString();
            const regExp =
                /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
            const match = YTUrl.match(regExp);

            if (match && match[7].length == 11) {
                return match[7];
            }
        }

        return false;
    }


    isWithinADay(date) {
        if (!date || date == "") {
            return "";
        }
        const currentDateTime = new Date().getTime();
        const MsgDateTime = new Date(date).getTime();

        const diff = currentDateTime - MsgDateTime;
        // var diff_as_date = new Date(diff);
        // const days = diff_as_date.getDay();
        const oneDay = 1000 * 60 * 60 * 24;

        console.log(diff);

        return oneDay < diff ? true : false;

        // return currentDateTime - MsgdateTime > day;
    }

    // Return date in 'MMM d, y, h:mm:ss a' format
    formatedDateTime(date) {
        if (!date || date == "") {
            return "";
        }
        const dateTime = new Date(date);
        const dateTimeString = this.datepipe.transform(dateTime, "medium");

        return dateTimeString;
    }

    // Return date in '<mon> <DD>, <YYYY>' format
    formatedDate(date) {
        if (!date || date == "") {
            return "";
        }
        const endDate = new Date(date);
        const endDateString = this.datepipe.transform(endDate, "mediumDate");

        return endDateString;
    }

    // Return date in '<mon> <DD>' format
    formatedDateMon(date) {
        if (!date || date == "") {
            return "";
        }
        const endDate = new Date(date);
        const endDateString = this.datepipe.transform(endDate, "MMM d");

        return endDateString;
    }

    // Return date in '<YYYY>-<MM>-<DD>' format
    formatDateYYYYMMDD(date) {
        if (!date || date == "") {
            return "";
        }
        const newDate = new Date(date);
        const newDateString = this.datepipe.transform(newDate, "y-M-d");

        return newDateString;
    }

    // Return Days difference from 'date' to today
    daysLeft(date) {
        if (date == null || date == undefined) {
            return 0;
        }

        const date1 = new Date();
        const date2 = new Date(date);
        const timeDiff = date2.getTime() - date1.getTime();
        const daysLeft = Math.ceil(timeDiff / (1000 * 3600 * 24));

        return daysLeft;
    }

    // Return Seconds difference from 'date' to today
    timeDiff(date) {
        const date1 = new Date();
        const date2 = new Date(date);
        const timeDiff = date2.getTime() - date1.getTime();

        return timeDiff;
    }
    // Return difference from 'date' to today
    timeRemaining(date) {
        const date1 = new Date(date.replace(/-/g, "/"));
        const date2 = new Date();
        const timeDiff = Math.abs(date2.getTime() - date1.getTime());
        return timeDiff;
    }

    // Return difference between 2 dates
    dateDiff(dateCreated, dateEnd) {
        const date1 = new Date(dateCreated);
        const date2 = new Date(dateEnd);
        const timeDiff = Math.abs(date2.getTime() - date1.getTime());
        const totalDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

        return totalDays;
    }

    sec2Min(sec) {
        let min = sec / 60;
        min = +min.toFixed(2);

        return min;
    }

    sec2TimeDuration(sec) {
        let val = sec / 60;
        let min = Math.floor(val)
        let secn = Math.round((val - Math.floor(val)) * 60).toLocaleString('en-US', { minimumIntegerDigits: 2 })
        min = +min.toFixed(2);
        return (min + ':' + secn);
    }


    min2MinSec(decimal) {
        decimal = decimal ?? ""
        let min = decimal.toString().split(".")[0];
        let sec = "0";
        if (decimal.toString().split(".").length == 2) {
            sec = decimal.toString().split(".")[1];
        }

        sec = "0." + +sec;
        sec = Math.round(+sec * 60).toString();
        if (sec.length == 1) {
            sec = "0" + sec;
        }

        const duration = min + ":" + sec;
        return duration;
    }

    createRange(number) {
        let items: number[] = [];

        for (let i = 1; i <= number; i++) {
            items.push(i);
        }

        return items;
    }

    checkAudioType(type) {
        return type == "audio/mp3" ||
            type == "audio/mpeg" ||
            type == "audio/wav" ||
            type == "audio/x-wav" ||
            type == "audio/flac"
            ? true
            : false;
    }
    dcheckAudioType(type) {
        return type == "audio/wav" ||
            type == "audio/x-wav"
            // type == "audio/flac"
            ? true
            : false;
    }
    checkImageType(type) {
        return type == "image/png" ||
            type == "image/jpeg" ||
            type == "image/jpg"
            ? true
            : false;
    }



    owlNext(owlElement) {
        owlElement.next([200]);
    }

    owlPrev(owlElement) {
        owlElement.prev([200]);
    }

    resetForm(formDirective: FormGroupDirective) {
        formDirective.resetForm();
    }

    reload() {
        const activeRouterPath = this.router.url.split("?")[0];
        this.router.navigate(["/404"], {
            queryParams: { url: activeRouterPath },
            queryParamsHandling: "merge",
        });
    }

    scrollTo(id, speed = 300) {
        if (this.isBrowser) {
            $(".mainScrollable").animate(
                {
                    scrollTop:
                        $(".mainScrollable").scrollTop() +
                        $("#" + id).offset().top -
                        100,
                },
                speed
            );
        }
    }






    scrollToElem(elem, speed = 300, container = ".mainScrollable") {
        if (this.isBrowser) {
            var nav = $(elem);
            if (nav.length) {
                $(container).animate(
                    {
                        scrollTop:
                            $(container).scrollTop() + $(elem).offset().top - 120,
                    },
                    speed
                );
            }
        }
    }

    scroll(el) {
        el.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
        });
    }

    scrollToTop(speed = 0) {
        $(window).scrollTop(0);
        if (this.isBrowser) {
            $(".mainScrollable").animate({ scrollTop: 0 }, speed);

        }
    }

    replace(string, find, replace) {
        return string.split(find).join(replace);
    }

    copyInputMessage(inputElement) {
        if (this.isBrowser) {
            inputElement.select();
            document.execCommand("copy");

            // this.toastrService.success('Copied to clipboard');
        }
    }

    copyMessage(val: string) {
        const selBox = document.createElement("textarea");
        selBox.style.position = "fixed";
        selBox.style.left = "0";
        selBox.style.top = "0";
        selBox.style.opacity = "0";
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand("copy");
        document.body.removeChild(selBox);
    }

    parseHTML(encoded: string) {
        const elem = document.createElement("textarea");
        elem.innerHTML = encoded;
        const decoded = elem.value;
        elem.remove();
        return decoded;
    }

    trackEvent(category, action, label = this.router.url, dimensions = []) {

        let browser = "Other";

        if (this.isInstagram) {
            browser = "Instagram Web View";
        } else if (this.isFacebook) {
            browser = "Facebook Web View";
        } else if (this.uaLower.indexOf("edge") > -1) {
            browser = "Edge";
        } else if (this.uaLower.indexOf("opr") > -1 && !!(<any>window).opr) {
            browser = "Opera";
        } else if (
            this.uaLower.indexOf("chrome") > -1 &&
            !!(<any>window).chrome
        ) {
            browser = "Chrome";
        } else if (this.uaLower.indexOf("trident") > -1) {
            browser = "IE";
        } else if (this.uaLower.indexOf("firefox") > -1) {
            browser = "Firefox";
        } else if (this.uaLower.indexOf("safari") > -1) {
            browser = "Safari";
        } else {
            browser = "Other";
        }

        if (this.isBrowser) {
            /*(<any>window).ga("set", "dimension1", this.user.slug);
            (<any>window).ga("set", "dimension2", this.user.type);
            (<any>window).ga("set", "dimension3", browser);
            (<any>window).ga("set", "dimension4", this.router.url);
            (<any>window).ga("set", "dimension5", this.user.isProMember); // release_type

            dimensions.forEach((dimension) => {
                (<any>window).ga("set", dimension.key, dimension.value);
            });
        
            (<any>window).ga("send", "event", {
                eventCategory: category,
                eventAction: action,
                eventLabel: label,
                eventValue: 1,
            });*/





            if (category == 'Promo Tool Usage') {
                let stringWithoutKeywords = action;
                let stringsToBeRemoved = ["Claim_", "Download", "Pitch", "Copy"];
                stringsToBeRemoved.forEach(keyword => {
                    stringWithoutKeywords = stringWithoutKeywords.replace(new RegExp(keyword, 'gi'), '');

                })
                let dataLayer = (<any>window).dataLayer || [];
                dataLayer.push({
                    'event': category ? String(category).split(' ').join('_').toLowerCase() : '',
                    'event_category': category ? String(category).split(' ').join('_').toLowerCase() : '',
                    'event_action': action ? String(action).split(' ').join('_').toLowerCase() : '',
                    'event_label': label ? String(label).split(' ').join('_').toLowerCase() : '',
                    'tool_name': stringWithoutKeywords ? stringWithoutKeywords.split(' ').join('_').toLowerCase() : '',
                    'event_value': 1,
                    'user_slug': this.user.slug,
                    'user_type': this.user.type,
                    'isPro': this.user.isProMember,
                    'event_name': category ? String(category).split(' ').join('_').toLowerCase() : '',
                    'steps': action ? String(action).split(' ').join('_').toLowerCase() : '',
                });
                //console.log(dataLayer)
            } else {
                if (category.toLowerCase() != 'login' && category.toLowerCase() != 'register' && category.toLowerCase() != 'registration') {
                    let dataLayer = (<any>window).dataLayer || [];

                    //console.log("000000", label)
                    dataLayer.push({
                        'event': category ? String(category).split(' ').join('_').toLowerCase() : '',
                        'event_category': category ? String(category).split(' ').join('_').toLowerCase() : '',
                        'event_action': action ? String(action).split(' ').join('_').toLowerCase() : '',
                        'event_label': label ? String(label).split(' ').join('_').toLowerCase() : '',
                        'event_value': 1,
                        'user_slug': this.user.slug,
                        'user_type': this.user.type,
                        'isPro': this.user.isProMember,
                        'event_name': String(category) ? String(category).split(' ').join('_').toLowerCase() : '',
                        'steps': String(action) ? String(action).split(' ').join('_').toLowerCase() : '',

                    });
                    //console.log(dataLayer)
                }


            }

            let dataLayer = (<any>window).dataLayer || [];
            dataLayer.push({
                'event': "Link_Button_Click",
                'event_category': category ? String(category).split(' ').join('_').toLowerCase() : '',
                'event_action': action ? String(action).split(' ').join('_').toLowerCase() : '',
                'event_label': label ? String(label).split(' ').join('_').toLowerCase() : '',
                'event_value': 1,
                'user_slug': this.user.slug,
                'user_type': this.user.type,
                'isPro': this.user.isProMember,
                'event_name': category ? String(category).split(' ').join('_').toLowerCase() : '',
                'steps': action ? String(action).split(' ').join('_').toLowerCase() : '',
                'fromPageLocation': ''
            });
            //console.log(dataLayer)

        }

    }


    //epk
    gtmEvent(category, action, label = '', pagelocation = '') {

        let browser = "Other";

        if (this.isInstagram) {
            browser = "Instagram Web View";
        } else if (this.isFacebook) {
            browser = "Facebook Web View";
        } else if (this.uaLower.indexOf("edge") > -1) {
            browser = "Edge";
        } else if (this.uaLower.indexOf("opr") > -1 && !!(<any>window).opr) {
            browser = "Opera";
        } else if (
            this.uaLower.indexOf("chrome") > -1 &&
            !!(<any>window).chrome
        ) {
            browser = "Chrome";
        } else if (this.uaLower.indexOf("trident") > -1) {
            browser = "IE";
        } else if (this.uaLower.indexOf("firefox") > -1) {
            browser = "Firefox";
        } else if (this.uaLower.indexOf("safari") > -1) {
            browser = "Safari";
        } else {
            browser = "Other";
        }


        /** 
        * code for GTM dataLayer
        */

        let dataLayer = (<any>window).dataLayer || [];
        /*  let GtmParam:any=[]
          GtmParam = {
              'event':category,
              'event_category': category,
              'event_action': action,
              'event_label': label,
              'event_value': 1,
              'user_name': this.user.name,
              'user_slug': this.user.slug,
              'user_type': this.user.type,
              'browser': browser,
              'page_url': this.router.url,
              'user_email': this.user.email,
              'user_phone': this.user.mobile,
              'fromPageLocation':pagelocation
          } 
          console.log(GtmParam);*/
        dataLayer.push({
            'event': category ? String(category).split(' ').join('_').toLowerCase() : '',
            'event_category': category ? String(category).split(' ').join('_').toLowerCase() : '',
            'event_action': action ? String(action).split(' ').join('_').toLowerCase() : '',
            'event_label': label ? String(label).split(' ').join('_').toLowerCase() : '',
            'event_value': 1,
            'user_slug': this.user.slug,
            'user_type': this.user.type,
            'isPro': this.user.isProMember,
            'fromPageLocation': pagelocation,
            'event_name': category ? String(category).split(' ').join('_').toLowerCase() : '',
            'steps': action ? String(action).split(' ').join('_').toLowerCase() : '',
        });
        //console.log(dataLayer)

    }

    // distribution & upload & achivments & promo_tools & broadcast_video 
    gAEvents(name, steps, track_name = '', type = '', entry_point = '') {

        let browser = "Other";
        if (this.isInstagram) {
            browser = "Instagram Web View";
        } else if (this.isFacebook) {
            browser = "Facebook Web View";
        } else if (this.uaLower.indexOf("edge") > -1) {
            browser = "Edge";
        } else if (this.uaLower.indexOf("opr") > -1 && !!(<any>window).opr) {
            browser = "Opera";
        } else if (
            this.uaLower.indexOf("chrome") > -1 &&
            !!(<any>window).chrome
        ) {
            browser = "Chrome";
        } else if (this.uaLower.indexOf("trident") > -1) {
            browser = "IE";
        } else if (this.uaLower.indexOf("firefox") > -1) {
            browser = "Firefox";
        } else if (this.uaLower.indexOf("safari") > -1) {
            browser = "Safari";
        } else {
            browser = "Other";
        }

        let dataLayer = (<any>window).dataLayer || [];

        console.log(name, steps, track_name.toLocaleLowerCase(), type, entry_point, this.user.slug, this.user.type)
        if (name == 'promo_tool') {
            dataLayer.push({
                'event': name,
                'event_name': name,
                'steps': steps,
                'tool_name': type,
                'track_name': track_name.toLocaleLowerCase(),
                'type': '',
                'entry_point': entry_point,
                'event_value': 1,
                'user_slug': this.user.slug,
                'user_type': this.user.type,
                'isPro': this.user.isProMember,
            });
        } else {

            dataLayer.push({
                'event': name,
                'event_name': name,
                'steps': steps,
                'track_name': track_name.toLocaleLowerCase(),
                'type': type,
                'entry_point': entry_point,
                'event_value': 1,
                'user_slug': this.user.slug,
                'user_type': this.user.type,
                'isPro': this.user.isProMember,
            });
        }
        //console.log(dataLayer)
    }

    // login & registeration & opportunity & subscription 
    ga4Event(name, steps, slug = '', type = '', entry_point = '', error = '') {

        let browser = "Other";
        if (this.isInstagram) {
            browser = "Instagram Web View";
        } else if (this.isFacebook) {
            browser = "Facebook Web View";
        } else if (this.uaLower.indexOf("edge") > -1) {
            browser = "Edge";
        } else if (this.uaLower.indexOf("opr") > -1 && !!(<any>window).opr) {
            browser = "Opera";
        } else if (
            this.uaLower.indexOf("chrome") > -1 &&
            !!(<any>window).chrome
        ) {
            browser = "Chrome";
        } else if (this.uaLower.indexOf("trident") > -1) {
            browser = "IE";
        } else if (this.uaLower.indexOf("firefox") > -1) {
            browser = "Firefox";
        } else if (this.uaLower.indexOf("safari") > -1) {
            browser = "Safari";
        } else {
            browser = "Other";
        }

        let dataLayer = (<any>window).dataLayer || [];
        //console.log(name, steps.split(' ').join('_').toLowerCase(), slug.toLocaleLowerCase(), type, entry_point, this.user.slug, this.user.type, error)

        dataLayer.push({
            'event': name,
            'event_name': name,
            'steps': steps ? steps.split(' ').join('_').toLowerCase() : '',
            'slug': slug.toLocaleLowerCase(),
            'type': type,
            'entry_point': entry_point,
            'event_value': 1,
            'error': error,
            'user_slug': this.user.slug,
            'user_type': this.user.type,
            'isPro': this.user.isProMember,
        });
        //console.log(dataLayer)

    }







    virtualPageHit(url) {
        // console.log('Pageview Hit: ' + this.basePrefix + '/virtual/' + url);
        /* if (this.isBrowser) {
             (<any>window).ga("set", "page", "virtual/" + url);
         }*/
    }

    activeURLToShare() {
        return this.basePrefix + this.router.url.split("?")[0];
    }

    public getImageUrlStatus(url, type = "song", errorImage = "") {
        // console.log('komal imageSub[url]: ' + this.imageSub[url]);
        // console.log(url);
        // return url;
        if (
            this.imageDefaultValue[url] == undefined ||
            this.imageDefaultValue[url] == null
        ) {
            this.imageDefaultValue[url] = true;
            return "https://songdewnetwork.com/sgmedia/assets/images/default-album-art.png";
        }

        if (this.imageSub[url] != undefined && this.imageSub[url] != null) {
            return this.imageVal[url];
        }

        this.imageSub[url] = this.api.getImageUrlStatus(url).subscribe(
            (res) => {
                // console.log('1');
                // console.log(url);
                this.imageVal[url] = url;
                this.imageSub[url].unsubscribe();
                return url;
            },
            (err: HttpErrorResponse) => {
                // console.log('2');
                // console.log('Image Error Code: ', err.status);
                if (err.status == 200) {
                    // console.log(url);
                    this.imageVal[url] = url;
                    this.imageSub[url].unsubscribe();
                    return url;
                }

                let returnImage =
                    "https://songdewnetwork.com/sgmedia/assets/images/default-album-art.png";

                if (type == "") {
                }

                if (errorImage != "") {
                    returnImage = errorImage;
                }

                // console.log(returnImage);
                this.imageVal[url] = returnImage;
                this.imageSub[url].unsubscribe();
                return returnImage;
            }
        );
    }

    public getImageUrlStatusCode(url) {
        this.api.getImageUrlStatus(url).subscribe(
            (res) => {
                return 200;
            },
            (err: HttpErrorResponse) => {
                return err.status;
            }
        );
    }

    public decodeHtml(html) {
        const boldTag = /\<b\>/gi;
        const boldCloseTag = /\<\/b\>/gi;

        let decodedText = html == undefined || html == null ? "" : html;
        decodedText = decodedText.replace(boldTag, "");
        decodedText = decodedText.replace(boldCloseTag, "");

        var txt = document.createElement("textarea");
        txt.innerHTML = decodedText;
        return txt.value;
    }

    // Day's after which Cookie Expired

    cookieTime = 2;


    public mainScroll(event) {

        const angularthis = this;
        const dialogPosition: DialogPosition = {
            top: 100 + 'px'
        }
        // if (this.isBrowser) {
        //     const limit = (<any>window).innerHeight;
        //     const currentMainScrollablePos = $('.mainScrollable').scrollTop();
        //     // if (Math.abs(angularthis.mainScrollablePos - currentMainScrollablePos) > limit) {
        //     //     angularthis.trackEvent('scroll-pos', currentMainScrollablePos);
        //     //     angularthis.mainScrollablePos = currentMainScrollablePos;
        //     // }
        //     // console.log('different')
        //     // console.log(Math.abs(angularthis.mainScrollablePos - currentMainScrollablePos))

        // }




        // Exit Popup for Mobile


        //  To Stop Popup on certain URL

        // if (this.router.url.split('?')[0] == '/artist/distribute') {
        //     return
        // }

        // Stop to Upload Track
        if (this.router.url.split('?')[0] == '/upload/tracks') {
            return
        }

        // Stop to Upload New Videos
        if (this.router.url.split('?')[0] == '/upload/videos') {
            return
        }

        // Stop to Opportunity/something
        if ((this.router.url.split('?')[0]).split('/')[1] == 'opportunity' &&
            (this.router.url.split('?')[0]).split('/')[2] != undefined) {
            return
        }

        // Stop to Opportunities?something
        if ((this.router.url.split('?')[0]).split('/')[1] == 'opportunities' &&
            (this.router.url.split('?')[0]).split('/')[2] != undefined) {
            return
        }
    }

    //  Exit Popup for Desktop
    public openPopup() {

        //console.log(this.shoskeleBanner)
        //   Stop Popup on certain URL

        // if (this.router.url.split('?')[0] == '/artist/distribute') {
        //     console.log('Open Popup')
        //     return

        // }

        if (this.router.url.split('?')[0] == '/upload/tracks') {
            return
        }
        if (this.router.url.split('?')[0] == '/upload/videos') {
            return
        }

        // Stop to 
        // Stop to Opportunity/something
        if ((this.router.url.split('?')[0]).split('/')[1] == 'opportunity' &&
            (this.router.url.split('?')[0]).split('/')[2] != undefined) {
            return
        }
        // Stop to Opportunities?something
        if ((this.router.url.split('?')[0]).split('/')[1] == 'opportunities' &&
            (this.router.url.split('?')[0]).split('/')[3] != undefined && (this.router.url.split('?')[0]).split('/')[3] == 'apply') {
            return
        }

        // Open Popup when above url not present
        /*  if (this.isBrowser) {
              if (!this.getCookie('regExitPopup')) {
                  if (!this.user.slug) {
                      if (!this.getCookie('exit_pop-withoutLogin')) {
                          if (!(this.isMobile() || this.isTablet())) {
                              // Cookie set when user close the popup
                              this.setCookie("exit_pop-withoutLogin", 'true', this.cookieTime)
                              // Open Popup
                              this.dialog.closeAll();
                              this.popupDialogRef = this.dialog.open(ExitPopUpComponent, {data:{banner:this.shoskeleBanner, isOn:this.Is_set_shoskeleBanner}});
                          }
                      }
  
                  } else if (this.user.slug) {
                      if (!this.getCookie('exit_pop-Loginuser')) {
                          if (!(this.isMobile() || this.isTablet())) {
                              // Cookie set when user close the popup
                              this.setCookie("exit_pop-Loginuser", 'true', this.cookieTime)
                              // Open Popup
                              this.dialog.closeAll();
                              this.popupDialogRef = this.dialog.open(ExitPopUpComponent,{data:{banner:this.shoskeleBanner, isOn:this.Is_set_shoskeleBanner}});
                          }
                      }
  
                  }
  
  
              }
  
          }*/
    }

    getCookie(name: string) {
        let ca: Array<string> = document.cookie.split(";");
        let caLen: number = ca.length;
        let cookieName = `${name}=`;
        let c: string;

        for (let i: number = 0; i < caLen; i += 1) {
            c = ca[i].replace(/^\s+/g, "");
            if (c.indexOf(cookieName) == 0) {
                return c.substring(cookieName.length, c.length);
            }
        }
        return "";
    }

    deleteCookie(name) {
        this.setCookie(name, "", -1);
    }

    setCookie(
        name: string,
        value: string,
        expireDays: number,
        path: string = ""
    ) {
        let d: Date = new Date();
        d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
        let expires: string = `expires=${d.toUTCString()}`;
        let cpath: string = path ? `; path=${path}` : "";
        document.cookie = `${name}=${value}; ${expires}${cpath}`;
    }

    notificationImage(notification) {
        let img = "";

        if (
            notification.content_type === "clap_album" ||
            notification.content_type === "upload_album" ||
            notification.content_type === "album" ||
            notification.content_type === "album_social_media" ||
            notification.content_type === "album_out_now" ||
            notification.content_type === "album_insta_story" ||
            notification.content_type === "review_album" ||
            notification.content_type === "album_irc" ||
            notification.content_type === "album_promo" ||
            notification.content_type === "album_press_release" ||
            notification.content_type === "album_air" ||
            notification.content_type === "album_rcfa" ||
            notification.content_type === "album_qr_code" ||
            notification.content_type === "album_free_download" ||
            notification.content_type === "album_companion" ||
            notification.content_type === "added_album_in_blog" ||
            notification.content_type === "album_tv"
        ) {
            if (notification.object_details) {
                img = notification.object_details.cover_pic;
            }
        } else if (
            notification.content_type === "clap_song" ||
            notification.content_type === "upload_song" ||
            notification.content_type === "song" ||
            notification.content_type === "song_social_media" ||
            notification.content_type === "song_out_now" ||
            notification.content_type === "song_insta_story" ||
            notification.content_type === "review_song" ||
            notification.content_type === "song_irc" ||
            notification.content_type === "song_promo" ||
            notification.content_type === "song_press_release" ||
            notification.content_type === "song_air" ||
            notification.content_type === "song_rcfa" ||
            notification.content_type === "song_qr_code" ||
            notification.content_type === "song_free_download" ||
            notification.content_type === "song_companion" ||
            notification.content_type === "added_song_in_blog" ||
            notification.content_type === "song_tv"
        ) {
            if (notification.object_details) {
                img = notification.object_details.image;
            }
        } else if (
            notification.content_type === "clap_playlist" ||
            notification.content_type === "upload_playlist" ||
            notification.content_type === "added_song_in_playlist"
        ) {
            if (notification.object_details) {
                img = notification.object_details.cover_pic;
            }
        } else if (
            notification.content_type === "clap_video" ||
            notification.content_type === "upload_video"
        ) {
            if (notification.object_details) {
                img = notification.object_details.img_480x360;
            }
        } else if (
            notification.content_type === "Opp_live" ||
            notification.content_type === "Opp_incomplete_participation" ||
            notification.content_type === "Opp_winners_declared"
        ) {
            if (notification.object_details) {
                img = notification.object_details.gallery.contest_image_path;
            }
        } else if (notification.content_type === "added_artist_in_blog" || notification.content_type === "new_blog") {
            if (notification.object_details) {
                img = notification.object_details.featured_image;
            }
        } else if (notification.content_type === "TVplayoutOne" || notification.content_type === "TVplayoutTwo" || notification.content_type === "TVplayoutThree" || notification.content_type === "TVplayoutFour") {

            img = "https://songdewnetwork.com/sgmedia/img/tvnotifiction.jpeg";

        }
        else if (
            notification.actors &&
            notification.actors.length > 0 &&
            notification.actors[0].actor_dp
        ) {
            img = notification.actors[0].actor_dp;
        }

        if (img) {
            img = this.cropImage(img, 50);
        }

        return img;
    }

    notificationDefaultImage(notification) {
        if (
            notification.content_type === "clap_album" ||
            notification.content_type === "upload_album" ||
            notification.content_type === "album" ||
            notification.content_type === "album_social_media" ||
            notification.content_type === "album_out_now" ||
            notification.content_type === "album_insta_story" ||
            notification.content_type === "review_album" ||
            notification.content_type === "album_irc" ||
            notification.content_type === "album_promo" ||
            notification.content_type === "album_press_release" ||
            notification.content_type === "album_air" ||
            notification.content_type === "album_rcfa" ||
            notification.content_type === "album_qr_code" ||
            notification.content_type === "album_free_download" ||
            notification.content_type === "album_companion" ||
            notification.content_type === "added_album_in_blog" ||
            notification.content_type === "album_tv"
        ) {
            return "https://songdewnetwork.com/sgmedia/assets/images/default-album-art.png";
        } else if (
            notification.content_type === "clap_song" ||
            notification.content_type === "upload_song" ||
            notification.content_type === "song" ||
            notification.content_type === "song_social_media" ||
            notification.content_type === "song_out_now" ||
            notification.content_type === "song_insta_story" ||
            notification.content_type === "review_song" ||
            notification.content_type === "song_irc" ||
            notification.content_type === "song_promo" ||
            notification.content_type === "song_press_release" ||
            notification.content_type === "song_air" ||
            notification.content_type === "song_rcfa" ||
            notification.content_type === "song_qr_code" ||
            notification.content_type === "song_free_download" ||
            notification.content_type === "song_companion" ||
            notification.content_type === "added_song_in_blog" ||
            notification.content_type === "song_tv" ||
            notification.content_type === "Opp_winners_declared" ||
            notification.content_type === "Opp_shortlist"
        ) {
            return "https://songdewnetwork.com/sgmedia/assets/images/default-album-art.png";
        } else if (
            notification.content_type === "clap_playlist" ||
            notification.content_type === "upload_playlist" ||
            notification.content_type === "added_song_in_playlist"
        ) {
            return "https://songdewnetwork.com/sgmedia/assets/images/default-album-art.png";
        } else if (
            notification.content_type === "clap_video" ||
            notification.content_type === "upload_video"
        ) {
            return "https://songdewnetwork.com/sgmedia/assets/images/default-video-image.png";
        } else if (
            notification.content_type === "Opp_live" ||
            notification.content_type === "Opp_incomplete_participation" ||
            notification.content_type === "Opp_winner"
        ) {
            return "https://songdewnetwork.com/sgmedia/assets/images/default-opp-image.png";
        } else if (notification.content_type === "added_artist_in_blog") {
            return "https://songdewnetwork.com/sgmedia/assets/images/default-user.png";
        }

        return "https://songdewnetwork.com/sgmedia/assets/images/default-user.png";
    }




    canNotContainWhiteSpace(control: AbstractControl): ValidationErrors | null {
        let value;
        if (control.value != null) {
            value = control.value.trim();
        } else {
            value = "";
        }

        if (value == "") {
            return { required: true };
        }
        return null;
    }

    spaceCheck(value) {
        return value.includes(' ')

    }

    specialCharacterCheck(value) {
        return value.includes('<') || value.includes('>')
    }

    landingPage(is_new_user = false, data) {
        if (
            data.redirectTo != undefined &&
            data.redirectTo != null &&
            data.redirectTo != "" &&
            data.redirectTo != "/"
        ) {
            if (
                data.type == "opp" &&
                data.from == "apply" &&
                !this.user.isEmailVerified
            ) {
            } else {
                if (is_new_user) {
                    this.trackEvent(
                        "Registration",
                        "Success-landing-page",
                        data.redirectTo
                    );
                }

                this.router.navigate([data.redirectTo], {
                    queryParams: { login: null },
                    queryParamsHandling: "merge",
                });
            }
        } else {
            const activeRouterPath = this.router.url;

            if (
                (data.type != "" &&
                    data.type != undefined &&
                    data.type != null &&
                    data.type != "sign-in" &&
                    data.type != "register") ||
                activeRouterPath.indexOf("opportunity") > -1 ||
                activeRouterPath.indexOf("opportunities") > -1
            ) {
                if (is_new_user) {
                    this.trackEvent(
                        "Registration",
                        "Success-landing-page",
                        activeRouterPath
                    );
                }



                this.reload();
            } else {
                if (this.user.type == "Listener") {
                    if (is_new_user) {
                        this.trackEvent(
                            "Registration",
                            "Success-landing-page",
                            "/what-is-new"
                        );
                    }

                    this.router.navigate(["/what-is-new"]);
                } else {
                    if (is_new_user) {
                        this.trackEvent(
                            "Registration",
                            "Success-landing-page",
                            "/mydashboard"
                        );
                    }

                    this.router.navigate(["/mydashboard"]);
                }
            }
        }
    }

    invalidInputCheck(control: AbstractControl): { [key: string]: boolean } | null {
        // return value.includes(' ') ? 'space' : (value.includes('<') || value.includes('>')) ? 'invalidCharacter' : ''
        let value;
        if (control.value != null) {
            value = control.value.trim();
        } else {
            value = "";
        }

        if (value.includes('<') || value.includes('>')) {
            return { 'invalidInputCheck': true };
        }
        return null
    }

    forbiddenKeywords(control: AbstractControl): ValidationErrors | null {
        const forbidden = /<script|<\/script|<iframe|<object|<embed|<applet|<alert|<\/alert/i;
        return forbidden.test(control.value) ? { forbiddenKeyword: true } : null;
    }



}
